import axiosInstanceNew from "../lib/axiosinstanceNew";

const EhcTest = class {

    constructor(){
        this.baseUrl="ehc_test";
    }

  async AddechTest(data= []) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`,data));
  }
 
}

export default new EhcTest();